import { create } from 'zustand';

import { createSelectors } from '@/lib';

import { getTutorial, setTutorial } from './utils';

interface TutorialState {
  finished: boolean;
  hasFinishedOnce: boolean;
  index: number;
}

interface TutorialStore extends TutorialState {
  setIndex: (index: number) => void;
  finish: () => void;
  restart: () => void;
  hydrate: () => void;
}

const _useTutorial = create<TutorialStore>((set, get) => ({
  finished: false,
  hasFinishedOnce: false,
  index: 0,
  setIndex: (index) => {
    const { finished, hasFinishedOnce } = get();
    setTutorial({ index, finished, hasFinishedOnce });
    set({ index });
  },
  finish: () => {
    setTutorial({
      index: 0,
      finished: true,
      hasFinishedOnce: true,
    });
    set({ index: 0, finished: true, hasFinishedOnce: true });
  },
  restart: () => {
    const { hasFinishedOnce } = get();
    const state: TutorialState = {
      index: 0,
      finished: false,
      hasFinishedOnce,
    };
    setTutorial(state);
    set(state);
  },
  hydrate: () => {
    try {
      const tutorial = getTutorial();
      if (tutorial !== null) {
        const newState: TutorialState = {
          finished: tutorial.hasFinishedOnce,
          index: 0,
          hasFinishedOnce: tutorial.hasFinishedOnce,
        };
        setTutorial(newState);
        set(newState);
      } else {
        set({
          finished: false,
          index: 0,
          hasFinishedOnce: false,
        });
      }
    } catch (e) {
      console.error(e);
    }
  },
}));

export const useTutorial = createSelectors(_useTutorial);

export const setTutorialIndex = (index: number) =>
  _useTutorial.getState().setIndex(index);
export const finishTutorial = () => _useTutorial.getState().finish();
export const userCloseTutorial = () => _useTutorial.getState().finish();
export const restartTutorial = () => _useTutorial.getState().restart();
export const hydrateTutorial = () => _useTutorial.getState().hydrate();
